<template>
  <div id="horizontal-navbar">
    <div class="content-wrapper">
      <div class="sidebar-icon-wrapper">
        <img
          src="/static/icons/list-icon.svg"
          @click="showSidebar"
          v-if="showSidebarIcon"
          class="sidebar-icon"
        />
        <img
          src="/static/icons/list-icon.svg"
          v-if="!showSidebarIcon"
          @click="toggleSidebar"
          class="sidebar-icon"
        />
      </div>
      <div class="profile-section">
        <profile-section />
      </div>
    </div>
  </div>
</template>
<script>
import Variables from "@/assets/js/variables.js";
import NavbarContent from "@/components/modules/Layout/NavbarContent";
import ProfileSection from "@/components/modules/Layout/ProfileSection";
import { mapGetters } from "vuex";
export default {
  name: "HorizontalNavbar",
  components: {
    ProfileSection
  },
  data() {
    return {
      showIcons: undefined
    };
  },
  created() {
    this.pageTitle = this.$route.meta.pageTitle;
  },
  methods: {
    showSidebar() {
      this.$eventBus.showSidebar({
        bind: {
          is: NavbarContent
        }
      });
    },
    toggleSidebar() {
      this.$emit("toggleSidebar");
    }
  },
  computed: {
    ...mapGetters({
      getWindowWidth: "layout/getWindowWidth"
    }),
    showSidebarIcon() {
      return this.getWindowWidth < Variables.layout.navbarBreakpoint;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#horizontal-navbar {
  height: $horizontal-navbar-height;
  width: 100%;
  z-index: $Z-horizontal-navbar;
  position: absolute;
  top: 0;
  margin-top: 10px;
  padding-right: 20px;
  padding-left: 20px;
  background-color: transparent;
  .content-wrapper {
    height: calc(100%);
    display: flex;
    justify-content: space-between;
    background: white;
    box-shadow: $basic-shadow;
    border-radius: 8px;
    .sidebar-icon-wrapper {
      height: 100%;
      display: flex;
      align-items: center;
      margin-left: 10px;
      .sidebar-icon {
        cursor: pointer;
        height: 25px;
        width: 25px;
        &:hover {
          background: rgba(160, 160, 160, 0.2);
          border-radius: 3px;
        }
      }
    }
  }
}
@media (max-width: 500px) {
  #horizontal-navbar {
    padding-right: 10px !important;
    padding-left: 10px !important;
  }
}

@media (max-width: $navbar-breakpoint) {
  #horizontal-navbar {
    width: 100% !important;
  }
}
</style>
